export default "__VITE_ASSET__DRbx5Ovc__"